/**
 * What the page mounts (T018; 07-UX §55 debug UI separation).
 *
 * Production builds are always `game`: the player-facing session UI over the world. Development
 * builds may ask for a developer surface through the URL:
 *
 *   ?spike=render|giant|walls   a rendering spike scene instead of the match (T011 / T016)
 *   ?hud=fixture                the HUD over a server-less fixture (T014 review harness)
 *   ?shell=fixture&scene=…      the session UI + HUD over fixture data (T018 review harness)
 *   ?sandbox=1 / ?devpanel=1    the T002 connection panel (the DEV sandbox room, browser tests)
 *
 * Every developer surface is loaded with a dynamic `import()` behind `import.meta.env.DEV`, so
 * none of it reaches the production bundle (`tools/checkProdBundle.mjs` verifies the build).
 */
export type AppMode = 'game' | 'dev-panel' | 'spike' | 'hud-fixture' | 'shell-fixture';

export function parseAppMode(search: string, dev: boolean): AppMode {
  if (!dev) return 'game';
  const params = new URLSearchParams(search);
  if (params.get('spike') !== null) return 'spike';
  if (params.get('hud') === 'fixture') return 'hud-fixture';
  if (params.get('shell') === 'fixture') return 'shell-fixture';
  if (params.get('sandbox') === '1' || params.get('devpanel') === '1') return 'dev-panel';
  return 'game';
}

/** This page's mode (read once at load). */
export function resolveAppMode(): AppMode {
  if (!import.meta.env.DEV || typeof location === 'undefined') return 'game';
  return parseAppMode(location.search, true);
}
